import { Component } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { TopBar } from './top-bar/top-bar';

@Component({
  selector: 'app-layout',
  imports: [TopBar, RouterOutlet],
  templateUrl: './layout.html',
  styleUrl: './layout.scss',
  standalone: true,
})
export class Layout {

  public get unauthorizedUser(): boolean {
    return this.router.url.startsWith('/unauthorized');
  }

  constructor(private readonly router: Router) { }

}
